export const PIN_KEY = 'reportpad.workspace';

export interface PinDeps {
  search: string; // window.location.search
  storage: Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;
  listWorkspaces(): Promise<Array<{ id: string }>>;
  meWorkspaceId(): Promise<string>;
}

/** Pick the tab's workspace: valid ?w=, then stored pin, then me's workspace. */
export async function establishPin(deps: PinDeps): Promise<string> {
  const fromUrl = new URLSearchParams(deps.search).get('w');
  const stored = deps.storage.getItem(PIN_KEY);
  const ids = new Set((await deps.listWorkspaces()).map((w) => w.id));
  const chosen =
    [fromUrl, stored].find((c): c is string => !!c && ids.has(c)) ?? (await deps.meWorkspaceId());
  deps.storage.setItem(PIN_KEY, chosen);
  return chosen;
}

export function clearPin(storage: Pick<Storage, 'removeItem'>): void {
  storage.removeItem(PIN_KEY);
}
